import type { ReactNode } from 'react'
import { cn, pageContentClass } from '../../lib/ui'

type Props = {
  children: ReactNode
  className?: string
}

export function PageShell({ children, className }: Props) {
  return <div className={cn(pageContentClass, className)}>{children}</div>
}
